import { useLineClamp } from "../hooks/lineclamp";

interface LineClampProps {
  text: string;
  lines?: number;
  className?: string;
}

export const LineClamp = ({ text, lines = 1, className }: LineClampProps) => {
  const ref = useLineClamp(lines);

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={className}
      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
    >
      {text}
    </div>
  );
};
